import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface NotionUxInputProps {
  onNotionUxChange: (value: string) => void;
  notionUxValue: string;
  isEnabled: boolean;
}

export const NotionUxInput: React.FC<NotionUxInputProps> = ({
  onNotionUxChange,
  notionUxValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="NOTION (UX)"
      label="Enter NOTION (UX) link:"
      placeholder="https://notion.so/..."
      value={notionUxValue}
      onChange={onNotionUxChange}
      isEnabled={isEnabled}
    />
  );
};